<template>
  <div class="timeline">
    <HeroBanner :title="'Your Dashboard'" v-if="!shouldShowClientStuff"/>
    <!-- Head -->
    <div class="head">
      <TimelineStepper v-if="shouldShowClientStuff"/>
    </div>
    <!-- Next Step -->
    <NextStep v-if="shouldShowClientStuff"/>

    <!-- Timeline -->
    <Timeline v-if="shouldShowClientStuff && shouldShowTimeline"/>

    <!-- Admin dashboard -->
    <AdminDashboard v-if="shouldShowAdminStuff"/>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import AdminDashboard from '@/components/AdminDashboard'
import HeroBanner from '@/components/HeroBanner'
import NextStep from '@/components/NextStep'
import Timeline from '@/components/Timeline'
import TimelineStepper from '@/components/TimelineStepper'

export default {
  name: 'Dashboard',
  components: {
    AdminDashboard,
    HeroBanner,
    NextStep,
    Timeline,
    TimelineStepper
  },
  data() {
    return {
      clients: [],
    }
  },
  computed: {
    ...mapGetters([
      'currentUserProfile',
      'getStepOwner',
      'totalSteps'
    ]),
    ...mapState([
      'isAdmin',
      'queriedUserProfile',
      'userProfile'
    ]),
    isOnLastStep() {
      return this.currentUserProfile?.timelineStep === this.totalSteps
    },

    shouldShowAdminStuff() {
      return (this.isAdmin || this.currentUserProfile?.isAdmin) && !this.queriedUserProfile
    },
    shouldShowTimeline() {
      return this.currentUserProfile?.timelineStep !== null || this.isAdmin || this.currentUserProfile?.isAdmin
    },
    shouldShowClientStuff() {
      if (!this.currentUserProfile) {
        return false
      }
      if (this.isAdmin || this.currentUserProfile?.isAdmin) {
        if (this.queriedUserProfile && this.userProfile) {
          return this.queriedUserProfile.uid !== this.userProfile.uid
        }
        else {
          return false
        }
      }
      return true
    }
  },
  methods: {
    ...mapActions([
      'setTimelineStep'
    ])
  }
}
</script>

<style lang="scss" scoped>
.timeline {
  flex-direction: column;
  text-align: center;
  .head {
    display: block;
    width: 100%;
    text-align: center;
    &__title {
      font-size: 2rem;
    }
  }
}
</style>
